import { useTheme } from '@/core/utils/theme';
import { Button } from '@/shared/ui/button';
import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="w-10 h-10 p-0 rounded-xl glass-effect"
        disabled
      >
        <div className="w-4 h-4 bg-muted-foreground/20 rounded animate-pulse" />
      </Button>
    );
  }

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  // 图标显示切换目标：浅色模式下显示月亮（点击进入深色），反之亦然
  const getIcon = () => {
    return theme === 'light' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />;
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className="w-10 h-10 p-0 rounded-xl glass-effect hover:bg-primary/10 transition-all duration-300 group"
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      <div className="group-hover:scale-110 transition-transform">
        {getIcon()}
      </div>
    </Button>
  );
}
